const ControlEvents = [
    'requestPlay',
    'requestSeek',
    'requestPause',
    'requestBitrate',
];

export default ControlEvents;



// WEBPACK FOOTER //
// ./src/js/events/control-events.js